/*jshint esversion: 6*/

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './select.css';
import './switch.css';
import './react-player.css';
import {BrowserRouter as Router, Link, Route, Routes} from "react-router-dom";
import ReactPlayer from "react-player";
import {SaveTheDate} from "./SaveTheDate";
import Music from "./Music";
import Modal from "react-modal";
import {NavBar} from "./NavBar";
import {PhotoGallery} from "./PhotoGallery";
import {Slideshow} from "./Slideshow";
import {PhotoGrid} from "./PhotoGrid";
Modal.setAppElement('#root');

export const WEDDING_SONG_URL = "https://d381hui2s4gftp.cloudfront.net/01+-+Processional+Maid+of+Honor+Bridesmaids+and+Groomsmen+-+Pino+Donaggio+-+Telescope.mp3";

const PersistentMusicPlayer = ({shouldPlay}) => {
    return (
        <div style={{position: "fixed", width: 0, height: 0, overflow: "hidden", opacity: 0, pointerEvents: "none"}}>
            <ReactPlayer
                url={WEDDING_SONG_URL}
                playing={shouldPlay}
                controls={false}
                width="0"
                height="0"
                config={{file: {attributes: {controlsList: "nodownload"}}}}
            />
        </div>
    );
};

const App = () => {
    const [shouldPlay, setShouldPlay] = React.useState(false);

    return (
        <Router>
            <NavBar setShouldPlay={setShouldPlay}/>
            <PersistentMusicPlayer shouldPlay={shouldPlay}/>
            <Routes>
                <Route
                    exact
                    path="/"
                    element={<SaveTheDate shouldPlay={shouldPlay} setShouldPlay={setShouldPlay}/>}
                />
                <Route
                    path="/music"
                    element={<Music />}
                />
                <Route
                    path="/pictures"
                    element={<PhotoGallery/>}
                />
                <Route
                    path="/slideshow/:key"
                    element={<Slideshow shouldPlay={shouldPlay} setShouldPlay={setShouldPlay}/>}
                />
                <Route
                    path="/grid/:key"
                    element={<PhotoGrid/>}
                />
            </Routes>
        </Router>
    );
};

ReactDOM.render(<App />, document.getElementById('root'));